import { useEffect } from 'react';
import { Outlet, Navigate, useParams } from 'react-router-dom';
import { DefaultLayout } from 'layouts';
import { locations } from 'services/routes/locations';
import { Guidelines } from '../components';
import { Container } from './styled';

const ReleaseLayout = () => {
  const { releaseId } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!releaseId) {
    return <Navigate to={locations.general.discovery} />;
  }

  return (
    <DefaultLayout hideFooter>
      <Container>
        <Outlet context={releaseId} />
        <Guidelines />
      </Container>
    </DefaultLayout>
  );
};

export default ReleaseLayout;
